import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { withNext } from './nextPath';
import { useAuth } from './useAuth';
import type { AppRole } from './types';

type ProtectedRouteProps = {
  children: ReactNode;
  allowedRoles: AppRole[];
};

/// Without a session, sends to the single login and back here after it (#271). With the wrong
/// role, sends away: the panel is reachable by URL, but only the backend decides what it shows.
export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, isBootstrapping, user } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '40vh' }}>
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={withNext('/login', location.pathname)} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/catalog" replace />;
  }

  return <>{children}</>;
}
